/**
 * Colours page wheel + selected-story state (React Colours.tsx parity).
 */
(function () {
  function init(root) {
    if (!root || root.dataset.llColoursReady === '1') return;
    root.dataset.llColoursReady = '1';

    var dataEl = root.querySelector('[data-ll-colours-json]');
    var colors = [];
    try {
      colors = JSON.parse(dataEl && dataEl.textContent ? dataEl.textContent : '[]');
    } catch (e) {
      colors = [];
    }
    if (!colors.length) return;

    var selectedIndex = 3;
    var hoveredIndex = null;
    var spinning = true;
    var dark = false;

    var params = new URLSearchParams(window.location.search || '');
    var querySlug = (params.get('color') || params.get('colour') || '').toLowerCase();
    var path = (window.location.pathname || '').toLowerCase();
    var slugMatch = path.match(/\/(?:pages\/)?colou?rs\/([a-z0-9-]+)\/?$/);
    var initialSlug = querySlug || (slugMatch ? slugMatch[1] : '');
    if (initialSlug) {
      var slugIdx = colors.findIndex(function (c) { return c.value === initialSlug; });
      if (slugIdx >= 0) selectedIndex = slugIdx;
    }

    var rays = root.querySelector('[data-ll-colours-rays]');
    var minis = root.querySelectorAll('[data-ll-colour-mini]');
    var cards = root.querySelectorAll('[data-ll-colour-card]');
    var nameEl = root.querySelector('[data-ll-colour-name]');
    var meaningEl = root.querySelector('[data-ll-colour-meaning]');
    var descEl = root.querySelector('[data-ll-colour-desc]');
    var swatchEl = root.querySelector('[data-ll-colour-swatch]');
    var shopBtn = root.querySelector('[data-ll-colour-shop]');
    var shopTpl = (shopBtn && shopBtn.getAttribute('data-shop-template')) || 'Shop {{color}}';
    var hero = root.querySelector('[data-ll-colours-hero]');
    var darkBtn = root.querySelector('[data-ll-colours-dark]');
    var spinBtn = root.querySelector('[data-ll-colours-spin]');
    var spinLabelPlay = spinBtn && spinBtn.getAttribute('data-label-spin');
    var spinLabelPause = spinBtn && spinBtn.getAttribute('data-label-pause');
    var grid = root.querySelector('[data-ll-colours-grid]');

    function displayIndex() {
      return hoveredIndex !== null ? hoveredIndex : selectedIndex;
    }

    function lightBorder(hex) {
      return hex === '#FFFFFF' || hex === '#FCF8ED';
    }

    function paintRay(el, color, active) {
      el.style.background =
        'linear-gradient(to bottom, transparent 0%, ' + color.hex + ' 15%, ' + color.hex + ' 65%, transparent 95%)';
      el.style.filter = active ? 'drop-shadow(0 0 8px ' + color.hex + ')' : 'none';
      el.classList.toggle('is-active', active);
    }

    function render() {
      var i = displayIndex();
      var color = colors[i];
      if (!color) return;

      if (nameEl) nameEl.textContent = color.name;
      if (meaningEl) meaningEl.textContent = color.meaning;
      if (descEl) descEl.textContent = color.description;
      if (swatchEl) {
        swatchEl.style.backgroundColor = color.hex;
        swatchEl.style.boxShadow = lightBorder(color.hex)
          ? 'inset 0 0 0 1px rgba(0,0,0,0.1), 0 8px 24px ' + color.hex + '40'
          : '0 8px 24px ' + color.hex + '40';
        swatchEl.setAttribute('href', color.shopUrl);
      }
      if (shopBtn) {
        shopBtn.setAttribute('href', colors[selectedIndex].shopUrl);
        var label = shopBtn.querySelector('[data-ll-colour-shop-label]');
        if (label) {
          label.textContent = shopTpl.replace('__COLOR__', colors[selectedIndex].name).replace(/\{\{\s*color\s*\}\}/g, colors[selectedIndex].name);
        }
      }

      if (hero && !dark) {
        hero.style.background =
          'linear-gradient(135deg, ' + color.hex + '14 0%, #fff 50%, ' + color.hex + '0d 100%)';
      }

      if (rays) rays.classList.toggle('is-paused', !spinning);
      if (spinBtn) spinBtn.textContent = spinning ? spinLabelPause : spinLabelPlay;
      root.classList.toggle('ll-colours-page--dark', dark);
      if (darkBtn) {
        darkBtn.setAttribute('aria-pressed', dark ? 'true' : 'false');
        var moon = darkBtn.querySelector('.ll-colours-icon-moon');
        var sun = darkBtn.querySelector('.ll-colours-icon-sun');
        if (moon) moon.hidden = dark;
        if (sun) sun.hidden = !dark;
      }

      minis.forEach(function (btn, idx) {
        btn.classList.toggle('is-active', idx === selectedIndex);
        btn.setAttribute('aria-checked', idx === selectedIndex ? 'true' : 'false');
      });
      cards.forEach(function (card, idx) {
        card.classList.toggle('is-active', idx === selectedIndex);
        var bar = card.querySelector('[data-ll-colour-bar], .ll-colours-card__bar');
        if (bar && colors[idx] && colors[idx].hex) {
          bar.style.backgroundColor = colors[idx].hex;
          bar.style.setProperty('--ll-bar-color', colors[idx].hex);
        }
      });

      var rayBtns = rays ? rays.querySelectorAll('[data-ll-colour-ray]') : [];
      rayBtns.forEach(function (btn, idx) {
        var active = idx === selectedIndex || idx === hoveredIndex;
        paintRay(btn, colors[idx], active);
        btn.classList.toggle('is-hover', idx === hoveredIndex && idx !== selectedIndex);
      });
    }

    function select(i) {
      selectedIndex = i;
      spinning = false;
      render();
    }

    if (rays) {
      colors.forEach(function (color, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'll-colours-ray';
        btn.setAttribute('data-ll-colour-ray', color.value);
        btn.setAttribute('aria-label', color.name);
        btn.style.transform = 'rotate(' + (i * 360) / 20 + 'deg)';
        btn.addEventListener('click', function () { select(i); });
        btn.addEventListener('mouseenter', function () {
          hoveredIndex = i;
          render();
        });
        btn.addEventListener('mouseleave', function () {
          hoveredIndex = null;
          render();
        });
        rays.appendChild(btn);
      });
    }

    minis.forEach(function (btn, i) {
      btn.addEventListener('click', function () { select(i); });
    });

    if (darkBtn) {
      darkBtn.addEventListener('click', function () {
        dark = !dark;
        if (dark && hero) hero.style.background = '#1a1a1a';
        render();
      });
    }

    if (spinBtn) {
      spinBtn.addEventListener('click', function () {
        spinning = !spinning;
        render();
      });
    }

    root.querySelectorAll('[data-ll-scroll-grid]').forEach(function (el) {
      el.addEventListener('click', function () {
        if (grid) grid.scrollIntoView({ behavior: 'smooth' });
      });
    });

    render();
  }

  function boot() {
    document.querySelectorAll('[data-ll-colours-page]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
